import { Component, OnDestroy } from '@angular/core';
import { Router, RouterOutlet } from '@angular/router';
import { DefaultComponent } from '../../component/default.component';
import { SettingsService, UserInteractionsService } from '../../shared/service';

@Component({
  selector: 'tratt-members-area',
  templateUrl: './intern.component.html',
  styleUrls: ['./intern.component.scss'],
  providers: [UserInteractionsService],
  imports: [RouterOutlet],
})
export class InternComponent extends DefaultComponent implements OnDestroy {
  constructor(
    private router: Router,
    private settService: SettingsService,
  ) {
    super();
    document.body.setAttribute('style', 'overflow:hidden');
  }

  override ngOnDestroy() {
    super.ngOnDestroy();
    document.body.removeAttribute('style');
  }
}
